import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import { useToggle } from '../../../hooks';

type Props = {
  sortKey: string,
  order: string,
  updateSortKey: () => void,
  updateOrder: () => void,
}

export default function SortDropdown({ sortKey, order, updateSortKey, updateOrder }: Props) {
  const { on, toggle } = useToggle();
  return (
    <Dropdown isOpen={on} toggle={toggle}>
      <DropdownToggle caret>
        Sort By
          </DropdownToggle>
      <DropdownMenu>
        <DropdownItem header>Sort By</DropdownItem>
        <DropdownItem
          className={sortKey === 'price' ? 'active' : ''}
          onClick={() => updateSortKey('price')}
        >
          Price
        </DropdownItem>
        <DropdownItem
          className={sortKey === 'ratings' ? 'active' : ''}
          onClick={() => updateSortKey('ratings')}
        >
          Average Ratings
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem header>Order</DropdownItem>
        <DropdownItem
          className={order === 'desc' ? 'active' : ''}
          onClick={() => updateOrder('desc')}
        >
          Highest First
        </DropdownItem>
        <DropdownItem
          className={sortKey === 'asc' ? 'active' : ''}
          onClick={() => updateOrder('asc')}
        >
          Lowest First
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Lodge/Listings/SortDropdown.js